module.exports = __webpack_public_path__ + "static/media/riceVid.aee57c92.mp4";